import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { Constants } from '../constants/constants';
import { Location } from '../shared/model/location';
import { DatePipe } from '@angular/common';
import { ToastService } from '../service/toast.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-fmc-dashboard',
  templateUrl: './fmc-dashboard.component.html',
  styleUrls: ['./fmc-dashboard.component.scss'],
  providers: [DatePipe]
})
export class FmcDashboardComponent implements OnInit {

  @ViewChild('gmap', { static: true }) gmap: ElementRef;
  map: google.maps.Map;
  directionsService: any;
  locations: Array<Location> = new Array();
  selectedLocation: any = {};
  accountCategory: string;
  defaultLocationSelected: boolean = false;
  driverList: Array<any> = new Array();
  vehicleList: Array<any> = new Array();
  setupRouteModal: any;
  selectedDriver: any;
  routesForLocation: any;
  directionsDisplayList: Array<any> = new Array();
  markerList: Array<any> = new Array();
  driverDetailList: Array<any> = [];
  alertData: Array<any> = [];
  facilityList: Array<any> = [];
  minimumCalanderDate = new Date();
  vehiclesFound: boolean = true;

  private COLOR_CODES = ["#000000", "#6B8E23", "#008080", "#483D8B", "#4B0082", "#C71585", "#8B4513", "#FF4500", "#8B0000"]

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private datePipe: DatePipe, private toast: ToastService) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.getFleetLocationList();
    this.selectedLocation = { address: { name: "" } };
    this.initSetupRouteModal();
    this.map = this.initMap();
  }

  onAlertsClick() {
    var vin = "";
    if (this.driverDetailList.length > 0) {
      vin = this.driverDetailList[0].vin;
    } else return;
    this.utilService.showSpinner();
    this.apiService.getAlerts(vin).then((data) => {
      this.utilService.hideSpinner();
      this.alertData = data;
      console.log("Alert for vin::", vin, "from API::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.onAlertsClick();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initMap() {
    var CENTER_LAT_LNG = new google.maps.LatLng(32.7756855, -96.8119181);
    var MapOptions = {
      zoom: 7,
      center: CENTER_LAT_LNG,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map(document.getElementById("map_canvas"), MapOptions);
    this.directionsService = new google.maps.DirectionsService();
    return map;
  }

  markerPlot(lat, lon, title, color) {
    console.log("request to add marker at::", lat, lon, title, color);
    var latlng = new google.maps.LatLng(lat, lon);
    var marker = new google.maps.Marker({
      title: title,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeColor: color,
        scale: 5
      },
      map: this.map,
      position: latlng
    });

    this.markerList.push(marker);
  }

  currentLocationMarkerPlot(lat, lon, title, color) {
    console.log("request to add marker at::", lat, lon, title, color);
    var latlng = new google.maps.LatLng(lat, lon);
    var marker = new google.maps.Marker({
      title: title,
      icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        strokeColor: color,
        scale: 3
      },
      map: this.map,
      position: latlng
    });

    this.markerList.push(marker);
  }

  clearMarkers() {
    for (var i = 0; i < this.markerList.length; i++) {
      this.markerList[i].setMap(null);
    }
    this.markerList = [];
  }

  calculateAndDisplayRoute(startLat, startLong, endLat, endLong, color, lineStroke, iconStroke) {
    console.log("calculate line called::", startLat, startLong, endLat, endLong, color, lineStroke, iconStroke);
    var directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: color,
        strokeOpacity: lineStroke,
        icons: [{
          icon: {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            strokeColor: color,
            strokeOpacity: iconStroke,
            scale: 1.5
          },
          repeat: '20px'
        }
        ]
      }
    });
    directionsDisplay.setMap(this.map);
    let that = this;
    this.directionsService.route({
      origin: new google.maps.LatLng(startLat, startLong),
      destination: new google.maps.LatLng(endLat, endLong),
      travelMode: google.maps.TravelMode.DRIVING
    }, function (response, status) {
      if (status === 'OK') {
        directionsDisplay.setDirections(response);
        that.directionsDisplayList.push(directionsDisplay);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  getFleetLocationList() {
    this.utilService.showSpinner();
    this.apiService.getFleetLocationList().then((data) => {
      this.utilService.hideSpinner();
      this.locations = data;
      console.log("Fleet locations from API::", this.locations);
      this.facilityList = [];
      data.forEach(element => {
        if (element.type == "FACILITY")
          this.facilityList.push(element);
      });
      if(this.locations && this.locations.length > 0)
        this.selectedLocation.address.name = this.locations[0].address.name;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getFleetLocationList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getRouteForLocation(locationId: string) {
    this.utilService.showSpinner();
    var date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    console.log("get route for the date::", date);
    this.apiService.getRouteForLocation(locationId, date).then((data) => {
      this.utilService.hideSpinner();
      this.routesForLocation = data;
      this.clearPreviousRoutesOnMap();
      this.clearMarkers();
      this.setRoutesForLocation();
      console.log("Routes for location from API::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getRouteForLocation(locationId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  setRoutesForLocation() {
    console.log("inside setRoutesForLocation()");
    if (this.routesForLocation == null)
      return;
    let that = this;
    for (var i = 0; i < this.routesForLocation.length; i++) {
      var color = (i < this.COLOR_CODES.length) ? this.COLOR_CODES[i] : this.getRandomColor();
      var stops = this.routesForLocation[i].stops;
      console.log("stops::", stops);

      //prepare routes
      var routeStops = [];
      routeStops.push(this.routesForLocation[i].startPoint);
      if (stops != null)
        stops.forEach(element => {
          routeStops.push(element);
        });
      routeStops.push(this.routesForLocation[i].endPoint);

      this.processRoutes(routeStops, this.routesForLocation[i].currentLocation, color);

      this.initDriverDetails(this.routesForLocation[i], color);
      console.log("driver detail list::", this.driverDetailList);
    }
  }

  processRoutes(stops, currentLocation, color) {
    console.log("stops::", stops, "currentlocation::", currentLocation, "color::", color);
    var startpoint = stops[0];
    this.markerPlot(startpoint.location.coordinate.latitude, startpoint.location.coordinate.longitude, "Route", color);
    for (var i = 1; i < stops.length; i++) {
      var endpoint = stops[i];
      this.markerPlot(endpoint.location.coordinate.latitude, endpoint.location.coordinate.longitude, "Route", color);
      this.drawMap(startpoint, endpoint, currentLocation, color);
      startpoint = endpoint;
    }
  }

  drawMap(startpoint, endpoint, currentLocation, color) {
    console.log("start point::", startpoint);
    console.log("end point::", endpoint);
    if (startpoint.status == 'PENDING') {
      this.calculateAndDisplayRoute(startpoint.location.coordinate.latitude, startpoint.location.coordinate.longitude, endpoint.location.coordinate.latitude, endpoint.location.coordinate.longitude, color, 0, 1);
    } else if (startpoint.status == 'ARRIVED' && endpoint.status == 'ARRIVED') {
      this.calculateAndDisplayRoute(startpoint.location.coordinate.latitude, startpoint.location.coordinate.longitude, endpoint.location.coordinate.latitude, endpoint.location.coordinate.longitude, color, 1, 0);
    } else if (startpoint.status == 'ARRIVED' && endpoint.status == 'PENDING') {
      this.currentLocationMarkerPlot(currentLocation.coordinate.latitude, currentLocation.coordinate.longitude, "Route", color);
      // initArrowMap(startpoint.latitude, startpoint.longitude, currentLocation.latitude, currentLocation.longitude, color);
      this.calculateAndDisplayRoute(startpoint.location.coordinate.latitude, startpoint.location.coordinate.longitude, currentLocation.coordinate.latitude, currentLocation.coordinate.longitude, color, 1, 0);
      this.calculateAndDisplayRoute(currentLocation.coordinate.latitude, currentLocation.coordinate.longitude, endpoint.location.coordinate.latitude, endpoint.location.coordinate.longitude, color, 0, 1);
    }
  }

  initDriverDetails(route, color) {
    console.log("init driver detail::", route, "color", color);
    var detail = {
      name: route.driver.name,
      vin: route.vehicle.vin,
      make: route.vehicle.make,
      model: route.vehicle.model,
      year: route.vehicle.year,
      color: color
    }
    this.driverDetailList.push(detail);
  }

  clearPreviousRoutesOnMap() {
    console.log("direction display::", this.directionsDisplayList);
    this.directionsDisplayList.forEach(element => {
      element.setMap(null);
    });
    this.directionsDisplayList = [];
    this.driverDetailList = [];
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getVehicleAtLocation(locationId: string) {
    this.vehiclesFound = true;
    this.vehicleList = new Array();
    this.utilService.showSpinner();
    this.apiService.getVehicleAtLocation(locationId).then((data) => {
      this.utilService.hideSpinner();
      this.vehicleList = data;
      if (isNullOrUndefined(this.vehicleList) || this.vehicleList.length < 1) {
        // this.toast.showError("No vehicles found");
        this.vehiclesFound = false;
      }
      console.log("Vehicle list  from API::", data, "for location", this.selectedLocation.id);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleAtLocation(locationId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getDrivers() {
    const requestPayload = {
      "accountId": this.authService.loggedInUser.accountId,
      "enterpriseId": this.authService.loggedInUser.enterpriseId,
      "roles": ["ROLE_FMC_DRIVER"]
    }
    this.utilService.showSpinner();
    this.apiService.getUsersByRole(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      this.driverList = data;
      console.log("Driver List ::", this.driverList);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDrivers();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  executeTelematicService() {
    if (this.driverDetailList == null || this.driverDetailList.length == 0)
      return;
    this.utilService.showSpinner();
    var payload = {
      "vin": this.driverDetailList[0].vin
    }
    this.apiService.executeTelematicService(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("Telematic location executed. Response ::", data);
      this.getRouteForLocation(this.facilityList[0].id);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.executeTelematicService();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  setupRouteForLocation(requestPayload: any) {
    this.utilService.showSpinner();
    this.apiService.setupRouteForLocation(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      // this.getUsersByRole();
      this.resetSetupRouteDriverForm();
      console.log("Route Creation response ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.setupRouteForLocation(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onSetupRouteClick() {
    this.resetSetupRouteDriverForm();
    this.getDrivers();
  }

  resetSetupRouteDriverForm() {
    // console.log("reset form called");
    this.initSetupRouteModal();
    this.vehicleList = new Array();
    var items = document.getElementsByTagName('select');
    for (var i = 0; i < items.length; i++) {
      // console.log("select items:", items[i]);
      items[i]["selectedIndex"] = 0;
    }
  }

  onDashboardLocationChange(index: number) {
    console.log("on dashboard location change::", index);
    if (index >= 0) {
      this.getRouteForLocation(this.facilityList[index].id);
      this.selectedLocation = this.facilityList[index];
    }
    this.alertData = [];
  }

  onDriverSetupLocationChange() {
    console.log("on driver setup location change::", this.setupRouteModal.fleetLocation);
    if (this.setupRouteModal.fleetLocation) {
      this.getVehicleAtLocation(this.setupRouteModal.fleetLocation.id);
    }
  }

  onStopLocationChange(locationIndex: number, stopIndex: number) {
    console.log("selected stop::", locationIndex);
    this.setupRouteModal.stops[stopIndex].location.address = this.locations[locationIndex].address;
    this.setupRouteModal.stops[stopIndex].location.coordinate = this.locations[locationIndex].coordinate;
    this.setupRouteModal.stops[stopIndex].location.locationId = this.locations[locationIndex].id;
  }

  onSetupRouteDriver() {
    console.log("setup route driver payload::", this.setupRouteModal);
    document.getElementById("openSetupRouteCondition").click();
  }

  onSetupRouteConditions() {
    console.log("setup route conditions payload::", this.setupRouteModal);
    document.getElementById("openSetupRouteStops").click();
  }

  addStop() {
    var stop = {
      "estimatedArrivalTime": new Date(),//"2019-04-20T10:45:17.921Z",
      "location": {
        "address": null,
        "coordinate": null,
        "locationId": null
      }
    }
    this.setupRouteModal.stops.push(stop);
  }

  removeRoute(index: number) {
    if (this.setupRouteModal.stops.length > 1) {
      this.setupRouteModal.stops.splice(index, 1);
    }
  }

  onSetupRoutes() {
    console.log("setup route modal::", this.setupRouteModal);
    var requestPayload = this.prepareSetupRouteModalRequest();
    console.log("final route setup request payload::", requestPayload);
    this.setupRouteForLocation(requestPayload);
  }

  onCurfewStartTimeSelected() {
    this.setupRouteModal.curfew.endTime = this.setupRouteModal.curfew.startTime;
  }

  prepareSetupRouteModalRequest() {
    var payload = {
      "curfew": {
        "endTime": this.setupRouteModal.curfew.endTime,
        "startTime": this.setupRouteModal.curfew.startTime
      },
      "date": this.setupRouteModal.date,
      "driver": {
        "name": this.setupRouteModal.driver.name,
        "userId": this.setupRouteModal.driver.id
      },
      "endPoint": {
        "location": {
          "address": this.setupRouteModal.endPoint.location.address,
          "coordinate": this.setupRouteModal.endPoint.location.coordinate,
          "locationId": this.setupRouteModal.endPoint.location.id
        }
      },
      "fleetLocation": {
        "address": this.setupRouteModal.fleetLocation.address,
        "coordinate": this.setupRouteModal.fleetLocation.coordinate,
        "locationId": this.setupRouteModal.fleetLocation.id
      },
      "speedLimit": {
        "unit": "MLPH",
        "value": this.setupRouteModal.speedLimit.value
      },
      "startPoint": {
        "location": {
          "address": this.setupRouteModal.startPoint.location.address,
          "coordinate": this.setupRouteModal.startPoint.location.coordinate,
          "locationId": this.setupRouteModal.startPoint.location.id
        }
      },
      "stops": this.setupRouteModal.stops,
      "vehicle": this.setupRouteModal.vehicle
    };

    return payload;
  }

  initSetupRouteModal() {
    this.setupRouteModal = {
      "curfew": {
        "endTime": new Date(),
        "startTime": new Date()
      },
      "date": new Date(),//"2019-04-22T10:45:17.921Z", | date:'YYYY-MM-DDTHH:mm:ss.sssZ'
      "driver": null,
      "endPoint": {
        "location": null
      },
      "fleetLocation": null,
      "speedLimit": {
        "unit": "MLPH",
        "value": null
      },
      "startPoint": {
        "location": null
      },
      "stops": [
        {
          "estimatedArrivalTime": new Date(),//"2019-04-22T10:45:17.921Z",
          "location": {
            "address": null,
            "coordinate": null,
            "locationId": null
          }
        }
      ],
      "vehicle": null
    };
  }

}
